import "react-datepicker/dist/react-datepicker.css";
import { addDecisionMembers } from "../../../api/decision/decision-members";
import { getUserUnitsList } from "../../../api/organization-unit/organization-unit";
import { Button } from "../../Button";
import { Container, Row, Col } from "react-grid-system";
import SimpleSearch from "../../SimpleSearch";
import {
	StyledAddUpperUnitIcon,
	StyledAddUpperUnitOptions,
	StyledAddUpperUnitActions,
} from "../../../styles/StyledAddUpperUnit/StyledAddUpperUnit";
import { useDecisionContext } from "../../../context/decisionContext";
import { useAppContext } from "../../../context/appContext";
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import AddIcon from "../../../assets/img/icons/add.svg";
import icon from "../../../assets/img/upper-decision.png";
import PropTypes from "prop-types";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { SelectableSingleUnits } from "../../SelectableLists/SelectableUnits";

export default function AddDecisionMember({ onClick, isMaker, refetch }) {
	const { id } = useDecisionContext();
	const { items } = useAppContext();
	const { axiosPrivate } = useAxiosPrivate();

	const [unitSelectedID, setUnitSelectedID] = useState(null);
	const [phrase, setPhrase] = useState(null);
	const [resultData, setResultData] = useState([]);

	const { data, isLoading, isError, error } = useQuery(["user-units", phrase], () =>
		getUserUnitsList(axiosPrivate)
	);

	useEffect(() => {
		if (!isLoading && !isError && data) {
			let filteredData = data;
			
			// Filter to only show units where the user is owner or admin
			if (items.userUnits) {
				filteredData = data.filter(unit => {
					const userRoles = items.userUnits[unit.id];
					return userRoles && (userRoles.includes("owner") || userRoles.includes("admin"));
				});
			}
			
			if (phrase && phrase.trim()) {
				const searchTerm = phrase.toLowerCase().trim();
				filteredData = filteredData.filter(unit =>
					unit.name.toLowerCase().includes(searchTerm) ||
					(unit.description && unit.description.toLowerCase().includes(searchTerm))
				);
			}
			setResultData(filteredData);
		}
	}, [isLoading, data, phrase, isError, items.userUnits]);

	const setSelectedUnit = (unitId) => {
		setUnitSelectedID(unitId);
	};

	const AddUnit = async () => {
		await addDecisionMembers(axiosPrivate, refetch, isMaker, id, unitSelectedID);
		onClick();
	};

	return (
		<>
			<Container>
				<Row>
					<Col sm={2}>
						<StyledAddUpperUnitIcon>
							<img src={icon} alt="" />
						</StyledAddUpperUnitIcon>
					</Col>
					<Col sm={10}>
						<StyledAddUpperUnitOptions>
							<Row>
								<Col>
									<SimpleSearch isWhite setPhrase={setPhrase} />
								</Col>
							</Row>
							<Button
								onClick={() => {
									setPhrase(null);
								}}
								bg={false}
								small={true}
							>
								Clear filters
							</Button>
						</StyledAddUpperUnitOptions>
					</Col>
				</Row>
				<Row>
					<Col>
						<SelectableSingleUnits data={resultData} isLoading={isLoading} isError={isError} error={error} setUnitSelectedID={setSelectedUnit} />
					</Col>
				</Row>
				<Row>
					<Col>
						<StyledAddUpperUnitActions>
							<Button onClick={onClick} bg={false} small={true}>
								cancel
							</Button>
							<Button icon={AddIcon} onClick={AddUnit}>
								ADD DECISION {isMaker ? "MAKER" : "RECEIVER"}
							</Button>
						</StyledAddUpperUnitActions>
					</Col>
				</Row>
			</Container>
		</>
	);
}

AddDecisionMember.propTypes = {
	onClick: PropTypes.func,
	selectedUpperUnit: PropTypes.func,
	matters: PropTypes.array,
	isMaker: PropTypes.bool,
	membersData: PropTypes.array,
	refetch: PropTypes.func,
};
